<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
      <!-- <v-flex xs12>
        <v-select
          label="*Tipo de Usuário"
          :items="groupsOptions"
          multiple
          required
          max-height="400"
          v-model="result.groups"
          :rules="[ value => value.length >= 1 || 'Tipo é obrigatório.']"
        ></v-select>
      </v-flex> -->
      <v-flex xs12>
        <v-text-field
          label="*Nome de usuário"
          v-model="result.username"
          required
          :counter="30"
          maxlength="30"
          :rules="usernameRules"
          @input.native="doesUsernameExists"
        ></v-text-field>
        <v-text-field
          label="*Nome"
          v-model="result.first_name"
          :rules="[v => !!v || 'Nome é obrigatório']"
          required
        ></v-text-field>
        <v-text-field
          label="*Sobrenome"
          v-model="result.last_name"
          :rules="[v => !!v || 'Sobrenome é obrigatório']"
          required
        ></v-text-field>
        <v-text-field
          label="*E-mail"
          v-model="result.email"
          :rules="emailRules"
          required
        ></v-text-field>
        <v-text-field
          label="*CPF"
          mask="###.###.###-##"
          :rules="cpfRules"
          required
          v-model="result.cpf"
        ></v-text-field>
        <v-spacer></v-spacer>
          <v-btn color="primary"  @click.native="$emit('prev')" >voltar</v-btn>
          <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
      </v-flex>
    </v-layout>
  </v-form>

</template>

<script>
import api from '@/api'
export default {
  data () {
    return {
      groupsOptions: ['Aluna(o)', 'Mediador(a)', 'Administrador(a)'],
      result: {
        turma_set: []
      },
      options: {},
      usernameExists: false,
      data: null,
      menu: false,
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => this.validemail(v)
      ],
      cpfRules: [
        v => !!v || 'CPF é obrigatório',
        v => this.testaCPF(v)
      ],
      usernameRules: [
        v => !!v || 'Nome de usuário é obrigatório',
        v => !this.usernameExists || 'Username já existe',
        v => this.validuser(v)
      ],
      valid: true,
      menu2: false,
      genero: [
            {acron: 'F', tipo: 'Feminino'},
            {acron: 'M', tipo: 'Masculino'},
            {acron: 'O', tipo: 'Outro'}
      ]
    }
  },
  mounted () {
  },
  watch: {
    menu (val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.result.birthdate)
    } },
  beforeDestroy () {
  },
  methods: {
    doesUsernameExists () {
      var self = this
      api.request('GET', 'search-user?username=' + this.result.username)
        .then(resp => {
          if (resp.data.length >= 1) {
            self.usernameExists = true
          } else {
            self.usernameExists = false
          }

          console.log(self.usernameExists)
        })
    },
    validemail (value) {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'E-mail inválido'
    },
    validuser (value) {
      const pattern = /^([A-Za-z@.+\-_]+)$/
      return pattern.test(value) || 'Este campo pode conter apenas letras, números e os seguintes caracteres @ . + - _ .'
    },
    testaCPF (strCPF) {
      var Soma
      var Resto
      Soma = 0
      var i
      if (strCPF === '00000000000') return false;

      for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11)) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(9, 10))) return false || 'CPF inválido';

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto === 10) || (Resto === 11)) Resto = 0;
      if (Resto !== parseInt(strCPF.substring(10, 11))) return false || 'CPF inválido';
      return true;
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    proximo () {
      if (this.$refs.form.validate()) {
        var grupo = []
        grupo[0] = 'Admin'
        this.result.groups = grupo
        this.$emit('dados2', this.result)
        this.$emit('next')
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Empresas/CadastroSteps/Step2.vue